import type { PhoneApp } from '../app/phone.js';
import { formatAuNumber } from './format.js';

export function MissedView({ app }: { app: PhoneApp }) {
  const missed = app.store.missed.value;
  const recent = app.store.recent.value;
  const t = (iso: string) => new Date(iso).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' });
  return (
    <>
      <section class="card" aria-label="Missed calls">
        <div class="who">Missed</div>
        {missed.length === 0 ? <div class="sub">No missed calls in this session.</div> : null}
        <ul class="list">
          {missed.map((m) => (
            <li key={m.call_id}>
              <span>
                {m.remote_name || formatAuNumber(m.remote_number) || 'Unknown'} <span class="sub">{formatAuNumber(m.remote_number)}</span>
              </span>
              <span class="row">
                <span class="sub">{t(m.at)}</span>
                {m.remote_number ? <button onClick={() => void app.dial(m.remote_number!)}>Call back</button> : null}
              </span>
            </li>
          ))}
        </ul>
      </section>
      <section class="card" aria-label="Recent calls">
        <div class="who">Recent</div>
        <ul class="list">
          {recent.map((r) => (
            <li key={r.call_id}>
              <span>
                {r.direction === 'inbound' ? '↙' : '↗'} {r.remote_name || formatAuNumber(r.remote_number) || 'Unknown'}
              </span>
              <span class="sub">
                {r.outcome} · {t(r.ended_at)}
              </span>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
